import {
    CssBaseline,
    ThemeProvider,
    StyledEngineProvider,
    styled,
} from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import AppTheme from "Theme/AppTheme";
import MessageStore from "../../components/ManagerInteractions/Stores/MessageStore";
import AcxSnackBar from "../../components/UI/AcxSnackBar";
import AcxDrawer from "../../components/UI/Drawer/AcxDrawer";
import { LayoutDrawerStore } from "../../stores/Layout/LayoutDrawerStore";
import { useStore } from "../../utils/useStore";
import FocusTitleBar from "./FocusTitleBar";

const RootDiv = styled("div")({
    width: "100%",
    height: "100%",
});

type FocusPageProps = {
    title: string;
    onCancel?: () => void;
    children?: React.ReactNode;
    loading?: boolean;
    onSave?: () => Promise<void>;
    showSave?: boolean;
    saveText?: string;
    cancelText?: string;
    hideCancelButton?: boolean;
    onSaveAs?: () => void;
    showSaveAs?: boolean;
    saveAsText?: string;
    saveTooltip?: string;
    saveAsTooltip?: string;
};

const FocusPage: React.FC<FocusPageProps> = observer(
    (props: FocusPageProps) => {
        const drawerStore = useStore(LayoutDrawerStore);
        const messageStore = useStore(MessageStore);

        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={AppTheme}>
                    <CssBaseline />

                    <RootDiv>
                        <AcxSnackBar
                            open={messageStore.showMessage}
                            onClose={messageStore.showNextMessage}
                            message={messageStore.currentMessage?.text || ""}
                            severity={messageStore.currentMessage?.severity}
                        />

                        <FocusTitleBar
                            title={props.title}
                            onCancelClick={props.onCancel}
                            onSaveClick={props.onSave}
                            showSave={props.showSave}
                            saveText={props.saveText}
                            cancelText={props.cancelText}
                            loading={props.loading}
                            onSaveAsClick={props.onSaveAs}
                            showSaveAs={props.showSaveAs}
                            hideCancelButton={props.hideCancelButton}
                            saveAsText={props.saveAsText}
                        />

                        {props.children}

                        <div>
                            <AcxDrawer
                                customRootStyles={drawerStore.customRootStyles}
                                anchor={drawerStore.anchor}
                                open={drawerStore.isOpen}
                                collapsible={drawerStore.collapseSize}
                                variant={drawerStore.variant}
                                offsetPx={drawerStore.offsetPx}
                                offsetPosition={drawerStore.offsetPosition}
                                onDrawerClose={() => drawerStore.setOpen(false)}
                                drawerStore={drawerStore}
                                onDrawerOpen={() => drawerStore.setOpen(true)}
                                content={drawerStore.contentInjector?.()}
                            />
                        </div>
                    </RootDiv>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    },
);

export default FocusPage;
